'server only';

export class HttpError extends Error {
  constructor(
    public status: number,
    message: string
  ) {
    super(message);
    this.name = 'HttpError';
  }
}

export function handleApiError(error: unknown): Response {
  console.error('Unexpected error:', error);
  if (error instanceof HttpError) {
    return new Response(error.message, { status: error.status });
  }
  return new Response('Internal Server Error', { status: 500 });
}

export const getRuntimeEnv = () => {
  const processEnvs = process.env;
  const runtimeVariablesKeys = Object.keys(processEnvs).reduce(
    (accum: Record<string, string>, key: string) => {
      if (/^NEXT_RUNTIME_PUBLIC/.test(key)) {
        return {
          ...accum,
          [key]: processEnvs[key] ?? '',
        };
      }
      return accum;
    },
    {}
  );

  return runtimeVariablesKeys;
};
